import React from "react";

const CommonFooter = () => {
  return (
    <div>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2025 © Controlytics AI All Right Reserved</p>
       <p>
  Designed & Developed By{" "}
  <a
    className="link-primary"
    href="https://controlytics.ai/"
    target="_blank"
    rel="noreferrer"
  >
    Controlytics.AI
  </a>
</p>

      </div>
    </div>
  );
};

export default CommonFooter;
